define('views/blocks/CBOnDeliveryView',['jquery', 'underscore', 'backbone', 'router', 'app', 'ApiRequest', 'template!blocks/payments/cbondelivery', 'string'],

    function ($, _, Backbone, router, app, ApiRequest, cashTemplate, S) {

        var view, paymentMethod;

        var CBOnDeliveryView = Backbone.View.extend({
            //
            className: 'CBOnDelivery', //
            events: {

               // 'change input[name=return_money]': 'ChangeReturnMoney',

            },
            initialize: function (options) {
                view = this;
                view.paymentMethod = options.paymentMethod;
            },
            render: function () {

                view.$el.html(cashTemplate({
                    cart: app.getCart(),
                }));
                view.delegateEvents();

            },

        submit: function (e) {
                e.preventDefault();
            }

        });

        return CBOnDeliveryView;
    });
